import React, { useState } from 'react';
import Select from "../../../Component/Select";
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../../Component/CircularLoader";
import logo from "../../../assets/images/RMI-Logo.png";

const Fixit = () => {
    const [currentDate] = useState(new Date())
    const newDate = addDays(currentDate, 3);
    const [loading,setLoading] = useState(false)
    const [credentials,setCredentails] = useState({
        username: "RMI_Education",
        password: "RMI_bls025",
        clientId: "IhnChjFTk55eDsf",
        clientSecret: "H4QizHPLPeed3mL"
    });
    // State to handle form input values
    const [formData, setFormData] = useState({
        firstName: '',
        lastName:'',
        fatherName:"",
        gender:"",
        email: '',
        phoneNumber: '',
        cnicNumber:"",
        amount: '17000',
        address: '',
        currency: 'PKR',
    });

    // State to handle errors
    const [errors, setErrors] = useState({});


    let payload
    if(formData.currency === "PKR") {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.firstName+" "+formData?.lastName,
                CustomerMobile: formData?.phoneNumber??"",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                BillDetail01: [
                    {
                        fatherName:formData?.fatherName,
                        gender:formData?.gender,
                        cnicNumber:formData?.cnicNumber

                    }
                ]
            }
        ];
    }


    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the form data state
        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate the specific field on change
        validateField(name, value);
    };

// Real-time field validation
    const validateField = (name, value) => {
        let fieldError = {};

        switch (name) {
            case "email":
                if (!value) {
                    fieldError.email = "Email is required.";
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    fieldError.email = "Email address is invalid.";
                } else {
                    fieldError.email = ""; // Clear error if input is valid
                }
                break;
            case "firstName":
                if (!value) {
                    fieldError.firstName = "First Name is required.";
                } else {
                    fieldError.firstName = ""; // Clear error if input is valid
                }
                break;

            case "lastName":
                if (!value) {
                    fieldError.lastName = "Last Name is required.";
                } else {
                    fieldError.lastName = ""; // Clear error if input is valid
                }
                break;

            case "fatherName":
                if (!value) {
                    fieldError.fatherName = "Father Name is required.";
                } else {
                    fieldError.fatherName = ""; // Clear error if input is valid
                }
                break;

            case "gender":
                if (!value) {
                    fieldError.gender = "Gender is required.";
                } else {
                    fieldError.gender = ""; // Clear error if input is valid
                }
                break;

            case "phoneNumber":
                if (!value) {
                    fieldError.phoneNumber = "Phone number is required.";
                } else {
                    fieldError.phoneNumber = ""; // Clear error if input is valid
                }
                break;

            case "address":
                if (!value) {
                    fieldError.address = "Address is required.";
                } else {
                    fieldError.address = ""; // Clear error if input is valid
                }
                break;
            case "cnicNumber":
                if (!value) {
                    fieldError.cnicNumber = "CNIC is required.";
                } else {
                    fieldError.cnicNumber = ""; // Clear error if input is valid
                }
                break;
            default:
                break;
        }

        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };



    // Validate form inputs
    const validateForm = () => {
        const newErrors = {};

        // Check if the name field is empty
        if (!formData.firstName) newErrors.firstName = "First Name is required.";
        if (!formData.lastName) newErrors.LastName = "Last Name is required.";
        if (!formData.fatherName) newErrors.fatherName = "Father Name is required.";
        if (!formData.gender) newErrors.gender = "Gender is required.";
        if (!formData.cnicNumber) newErrors.cnicNumber = "CNIC is required.";
        if (!formData.phoneNumber) newErrors.phoneNumber = "Gender is required.";
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }
        if (!formData.address) newErrors.address = "Address is required.";
        setErrors(newErrors);

        // Return whether the form is valid or not
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();



        // Validate the form before submission
        const isValid = validateForm();
        if (!isValid) {
            // If the form has errors, prevent submission
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if(response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            }else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                // window.top.location.href = marketplaceUrl+"&callback_url=https://fixit.org.pk/thankyou-for-your-contribution";
                window.top.location.href = marketplaceUrl;
            }

            // return response.data;


        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }


    const genderData = [
        { id: 5, name: "Male", value: "Male" },
        { id: 6, name: "Female", value: "Female" },
    ];

    return (
        <div className="w-11/12 lg:w-2/4 md:w-4/5 bg-white border-4 rounded-lg shadow relative m-auto">
            <div className='w-full flex flex-col p-6 gap-2 bg-[#03787c] '>
                <div className="w-full flex items-center flex-col justify-center gap-4">
                    <img className='w-2/6' src={logo} alt={logo}/>
                    <h2 className="text-3xl text-white font-semibold">Registration Form - Basic Life Support (BLS) </h2>
                </div>

                <h3 className="text-md font-semibold text-white mt-0">Application detail:</h3>
                <ul className="list-disc list-inside text-white mt-0">
                    <li>Name entered here will be considered as FINAL and will be used for AHA website</li>
                    <li>Please make sure you enter a VALID and CURRENT email address.</li>
                    <li>You will receive your "Provider eBook”, “Heartcode Key" and "Course Completion eCard" on this email address.- - Submit your registration fee Rs. 17,000/- at UBL; Account Title: Rehman Medical Institute, Account no. 223819694, Branch Code: 0059. </li>
                </ul>
                <span className="text-md  text-white mt-0">Account Title: Rehman Medical Institute, Account no. 223819694, Branch Code: 0059.</span>
                <span className="text-md  text-white mt-0">After completing the online registration and fee submission, kindly send the paid challan or screenshot of submission to the specified email address at tca.ahabls@rmi.edu.pk or via WhatsApp at 0300-5866765.</span>

            </div>
            <form className="p-6 space-y-6" onSubmit={payproCreateOrder}>

                <div className="grid grid-cols-1 gap-6">

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Email <span>*</span></label>
                        <input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Your Email Address"
                        />
                        {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
                    </div>
                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">First Name (+ Middle Name) <span>*</span></label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData?.firstName}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="First Name"
                        />
                        {errors.firstName && <p className="text-red-600 text-sm">{errors.firstName}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Last Name <span>*</span></label>
                        <input
                            type="text"
                            name="lastName"
                            value={formData?.lastName}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Last Name"
                        />
                        {errors.lastName && <p className="text-red-600 text-sm">{errors.lastName}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Father Name <span>*</span></label>
                        <input
                            type="text"
                            name="fatherName"
                            value={formData?.fatherName}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Last Name"
                        />
                        {errors.fatherName && <p className="text-red-600 text-sm">{errors.fatherName}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Gender <span>*</span></label>
                        <Select
                            selectValue={formData?.gender}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="gender"
                            data={genderData}
                        />
                        {errors.gender && <p className="text-red-600 text-sm">{errors.gender}</p>}
                    </div>



                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Phone Number <span>*</span></label>
                        <input
                            type="tel"
                            name="phoneNumber"
                            value={formData?.phoneNumber}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Phone Number"
                        />
                        {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Address (Hospital) </label>
                        <input
                            type="text"
                            name="address"
                            value={formData?.address}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Address"
                        />
                        {errors.address && <p className="text-red-600 text-sm">{errors.address}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">CNIC Number (Enter CNIC Without Dashes) <span>*</span></label>
                        <input
                            type="text"
                            name="cnic"
                            value={formData?.cnicNumber}
                            maxLength={13}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, ''); // Allow only numbers
                                if (value.length <= 13) {
                                    handleChange({ target: { name: "cnicNumber", value } });
                                }
                            }}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="XXXXXXXXXXXXX"
                        />
                        {errors.cnicNumber && <p className="text-red-600 text-sm">{errors.cnicNumber}</p>}
                    </div>
                </div>

                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="flex items-center gap-1  py-2 px-4 text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm"
                    >
                        Submit {loading ? <CircularLoader/> : null}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Fixit;